import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import Button from "react-bootstrap/Button";
import "./OutlineEditor.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ToggleButton from "react-bootstrap/ToggleButton";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import Spinner from "react-bootstrap/Spinner";
import { SlidePreview } from "../pages/SlidePreview";
import { faCirclePlay } from "@fortawesome/free-regular-svg-icons";
import { faRotateBack } from "@fortawesome/free-solid-svg-icons";
import { ProfileView } from "../pages/ProfileView";
import { title } from "process";

export const OutlineEditor = () => {
  function onRetry() {
    setSlides([]);
    try {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/regenerateReport",
          {
            audience: "",
            textLength: textLength,
            content: textValue,
            dateRange: dateRange,
            queryContent: textValue,
            partnerName: partnerName,
            partnerId: partnerId,
            owner: userProfile.email,
            numPages: numPages,
            reportId: reportId,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //   setReportId(response.data.reportId);
          setSlides(response.data.subtopics);
          setReportTitle(response.data.reportTitle);
          setNumPages(response.data.subtopics.length + " Slides");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  }
  function onClickBackToCopilot() {
    window.location.href = "/createReport?selected_index=" + selectedIndex;
  }

  function addCard() {
    setIsAddingSlide(true);
    let origin_num = numPages;

    let new_pages = parseInt(origin_num.split(" ")[0]) + 1;

    if (origin_num == "Surprise Me") {
      new_pages = slides.length + 1;
    }
    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/addSubtopic",
        {
          topic_id: reportId,
          dateRange: dateRange,
          content: "",
          contentSize: textLength,
          owner: userProfile.email,
          count: new_pages,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsAddingSlide(false);

        setSlides(response.data.subtopics);

        setReportTitle(response.data.report.title);

        setPartnerId(response.data.report.partner_id);

        setRadioContentName(response.data.report.content_size);
        setTextLength(response.data.report.content_size);

        setRadioNumPagesName(
          response.data.report.slide_numbers.toString() + " Slides"
        );
        setNumPages(response.data.report.slide_numbers.toString() + " Slides");

        setRadioDateName(response.data.report.daterange);
        setDateRange(response.data.report.daterange);

        setTextValue(response.data.report.topic);
        setPartnerName(response.data.partner.partner_name);
        setPartnerIcon(response.data.partner.icon);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function generateReport() {
    window.location.href =
      "/jam?reportId=" + reportId + "&selected_index=" + selectedIndex;
  }
  const queryParameters = new URLSearchParams(window.location.search);

  const [numRetries, setNumRetries] = useState(queryParameters.get(0));

  const [dateRange, setDateRange] = useState(queryParameters.get("dateRange"));
  const [isAddingSlide, setIsAddingSlide] = useState(false);

  const [numPages, setNumPages] = useState(queryParameters.get("numPages"));

  const [selectedIndex, setSelectedIndex] = useState(
    queryParameters.get("selected_index")
  );

  const [textLength, setTextLength] = useState(
    queryParameters.get("textLength")
  );

  const [queryContent, setQueryContent] = useState(
    queryParameters.get("queryContent")
  );

  const [partnerId, setPartnerId] = useState(queryParameters.get("partnerId"));

  const [partnerName, setPartnerName] = useState(
    queryParameters.get("partnerName")
  );

  const [partnerIcon, setPartnerIcon] = useState(
    queryParameters.get("partnerIcon")
  );

  const [reportId, setReportId] = useState(queryParameters.get("reportId"));
  const [slides, setSlides] = useState([]);
  const [reportTitle, setReportTitle] = useState("");

  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updated = Array.from(slides);
    const [movedItem] = updated.splice(result.source.index, 1);
    updated.splice(result.destination.index, 0, movedItem);
    setSlides(updated);
    updateSlidePosition(updated);
  };

  function updateSlidePosition(updated_slides) {
    var i = 1;
    for (var s in updated_slides) {
      let slide = updated_slides[s];
      slide.slide_position = i;
      i++;
    }
    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/reorderSlides",
        {
          slides: JSON.stringify(updated_slides),
          reportId: reportId,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setSlides(response.data.rows);
        console.log("NEW SLIDES", response.data.rows);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const dateRangeRadios = [
    { name: "1 month", value: "1" },
    { name: "3 months", value: "2" },
    { name: "6 months", value: "3" },
    { name: "1 Year", value: "4" },
  ];

  const examplePrompts = [
    "Regional Loan Volume",
    "Report on Performance By Credit Grade",
    "Collection Rates",
    "Loan Volume By Loan Type",
  ];

  const pageNumRadios = [
    { name: "Surprise Me", value: "0" },

    { name: "2 Slides", value: "1" },
    { name: "3 Slides", value: "2" },
    { name: "4 Slides", value: "3" },
    { name: "5 Slides", value: "4" },
    { name: "6 Slides", value: "5" },
    { name: "7 Slides", value: "6" },
    { name: "8 Slides", value: "7" },
    { name: "9 Slides", value: "8" },
    { name: "10 Slides", value: "9" },
  ];

  const amountOfTextRadios = [
    { name: "Brief", value: "1" },
    { name: "Medium", value: "2" },
    { name: "Detailed", value: "3" },
  ];

  const audienceRadios = [
    { name: "Executives", value: "1" },
    { name: "Analysts", value: "2" },
    { name: "Managers", value: "3" },
  ];

  const contentRadios = [
    { name: "Free Form", value: "1" },
    { name: "Card by Card", value: "2" },
  ];
  const textareaRef = useRef(null);
  const textareaRefTitle = useRef(null);
  const textareaRefOverview = useRef(null);

  const [textValue, setTextValue] = useState(queryContent);
  const [initialReportLoading, setInitialReportLoading] = useState(true);

  const onTextChange = (event) => setTextValue(event.target.value);

  const onReportTitleChange = (event) => setReportTitle(event.target.value);

  const onReportOverviewChange = (event) => setOverview(event.target.value);

  useEffect(() => {
    if (!initialReportLoading) {
      const delaySearch = setTimeout(() => {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/editReportTitle",
            {
              reportId: reportId,
              editedTitle: reportTitle,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }, 1000);

      return () => clearTimeout(delaySearch);
    }
  }, [reportTitle]);

  const [overview, setOverview] = useState();

  useEffect(() => {
    if (!initialReportLoading) {
      const delaySearch = setTimeout(() => {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/editReportOverview",
            {
              reportId: reportId,
              editedOverview: overview,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }, 1000);

      return () => clearTimeout(delaySearch);
    }
  }, [overview]);

  useLayoutEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "inherit";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textValue]);

  useLayoutEffect(() => {
    if (textareaRefTitle.current) {
      textareaRefTitle.current.style.height = "inherit";
      textareaRefTitle.current.style.height = `${textareaRefTitle.current.scrollHeight}px`;
    }
  }, [reportTitle]);

  useLayoutEffect(() => {
    if (textareaRefOverview.current) {
      textareaRefOverview.current.style.height = "inherit";
      textareaRefOverview.current.style.height = `${textareaRefOverview.current.scrollHeight}px`;
    }
  }, [overview]);

  const [radioNumPagesValue, setRadioNumPagesValue] = useState("0");
  const [radioNumPagesName, setRadioNumPagesName] = useState(numPages);
  console.log("BZZ", radioNumPagesName);

  if (radioNumPagesName == 0) {
    setRadioNumPagesName("Surprise Me");
  }

  const [checked, setChecked] = useState(false);
  const [radioDateValue, setRadioDateValue] = useState("2");
  const [radioDateName, setRadioDateName] = useState(dateRange);

  const [radioTextValue, setRadioTextValue] = useState("2");
  const [radioAudienceValue, setRadioAudienceValue] = useState("1");
  const [radioContentValue, setRadioContentValue] = useState("1");

  const [radioContentName, setRadioContentName] = useState(textLength);

  const onSelectContentLength = (eventKey, event) => {
    setRadioContentName(event.target.name);
    setRadioContentValue(event.target.value);
    setTextLength(event.target.name);
  };

  const onSelectPages = (eventKey, event) => {
    setRadioNumPagesName(event.target.name);
    setRadioNumPagesValue(event.target.value);
    setNumPages(event.target.name);
  };

  const onSelect = (eventKey, event) => {
    setRadioDateName(event.target.name);
    setRadioDateValue(event.target.value);
    setDateRange(event.target.name);
  };

  const onSelectPrompt = (prompt) => {
    console.log(prompt);
    setTextValue(prompt);
  };
  useEffect(() => {
    if (reportId == undefined && slides.length == 0) {
      try {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/generateReport",
            {
              audience: "",
              textLength: textLength,
              content: textValue,
              dateRange: dateRange,
              queryContent: textValue,
              partnerName: partnerName,
              partnerId: partnerId,
              owner: userProfile.email,
              numPages: numPages,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            setReportId(response.data.reportId);
            setSlides(response.data.subtopics);
            setReportTitle(response.data.reportTitle);
            setNumPages(response.data.subtopics.length + " Slides");
            setRadioNumPagesValue(response.data.subtopics.length + " Slides");
            setInitialReportLoading(false);
            setOverview(response.data.overview);

            // setRadioNumPagesName()
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error("Error processing message:", error);
      } finally {
      }
    } else {
      try {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/getReport",
            {
              reportId: reportId,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            // setSubTopics([response.data.subtopics[3]]);
            setSlides(response.data.subtopics);

            setReportTitle(response.data.report.title);
            setOverview(response.data.report.overview);

            setPartnerId(response.data.report.partner_id);

            setRadioContentName(response.data.report.content_size);
            setTextLength(response.data.report.content_size);

            setInitialReportLoading(false);

            if (response.data.report.slide_numbers == 0) {
              setRadioNumPagesName("Surprise Me");
              setNumPages("Surprise Me");
            } else {
              setRadioNumPagesName(
                response.data.report.slide_numbers.toString() + " Slides"
              );
              setNumPages(
                response.data.report.slide_numbers.toString() + " Slides"
              );
            }

            setRadioDateName(response.data.report.daterange);
            setDateRange(response.data.report.daterange);

            setTextValue(response.data.report.topic);
            setPartnerName(response.data.partner.partner_name);
            setPartnerIcon(response.data.partner.icon);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error("Error processing message:", error);
      } finally {
      }
    }
  }, [numRetries]);
  return (
    <div className="reportBackground">
      <ProfileView />
      <div className="cornerHeader">
        <Button
          className="backButton"
          onClick={onClickBackToCopilot}
          variant="light"
          size="sm"
        >
          Back
        </Button>
        {partnerName ? (
          <div className="editHeader">
            {partnerName.replace("_", " ")}{" "}
            <img className="buidlReportIcon" src={partnerIcon} alt="" />
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="editOutlineTitle">Generate Outline</div>

      {/* <div className="outlineHeader">Prompt</div> */}

      <div className="previewReportContainer">
        <Row>
          {/* Date Range
                  <br></br> */}
          <div className="optionRow">
            {/* <div className="promptHeader">Prompt</div> */}
            <div className="optionContainer">
              <div className="dropdownLabel">Number of Slides</div>

              <Dropdown onSelect={onSelectPages}>
                <Dropdown.Toggle
                  className="dropDown"
                  variant="secondary"
                  id="dropdown-basic"
                >
                  {radioNumPagesName}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {pageNumRadios.map((radio, idx) => (
                    <Dropdown.Item
                      key={`radioText-${idx}`}
                      id={`radioDate-${idx}`}
                      type="radio"
                      variant="secondary"
                      name={radio.name}
                      value={radio.value}
                      active={
                        radioNumPagesName === radio.name ||
                        (radioNumPagesName == 0 && radio.value == "Surprise Me")
                      }
                    >
                      {radio.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {/* Amount of Text Per Card <br></br> */}
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <div className="optionContainer">
              <div className="dropdownLabel">Date Range</div>

              <Dropdown onSelect={onSelect}>
                <Dropdown.Toggle
                  className="dropDown"
                  variant="secondary"
                  id="dropdown-basic"
                >
                  {radioDateName}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {dateRangeRadios.map((radio, idx) => (
                    <Dropdown.Item
                      key={`radioText-${idx}`}
                      id={`radioDate-${idx}`}
                      type="radio"
                      variant="secondary"
                      name={radio.name}
                      value={radio.value}
                      active={radioDateName === radio.name}
                    >
                      {radio.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {/* Amount of Text Per Card <br></br> */}
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <div className="optionContainer">
              <div className="dropdownLabel">Content Length</div>

              <Dropdown onSelect={onSelectContentLength}>
                <Dropdown.Toggle
                  className="dropDown"
                  variant="secondary"
                  id="dropdown-basic"
                >
                  {radioContentName}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {amountOfTextRadios.map((radio, idx) => (
                    <Dropdown.Item
                      key={`radioText-${idx}`}
                      id={`radioDate-${idx}`}
                      type="radio"
                      variant="light"
                      name={radio.name}
                      value={radio.value}
                      active={radioContentName === radio.name}
                    >
                      {radio.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <Col>
            <div className="regenRow">
              <Form.Group
                className="mb-3 w-100"
                controlId="exampleForm.ControlTextarea1"
              >
                <div>
                  <Form.Control
                    as="textarea"
                    ref={textareaRef}
                    placeholder="Ask anything about your data"
                    onChange={onTextChange}
                    value={textValue}
                    style={{
                      overflow: "hidden",
                      resize: "none",
                      minHeight: "40px",
                    }}
                  />
                </div>
              </Form.Group>
              <Button variant="link" onClick={onRetry}>
                <div className="regenerateButton">
                  {" "}
                  <FontAwesomeIcon icon={faRotateBack} size="lg" />
                </div>
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col> </Col>
        </Row>
      </div>

      {/* <div className="outlineHeader">Outline</div> */}
      {slides.length > 0 ? (
        <div className="reportOutline">
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="table-body">
              {(provided) => (
                <Container ref={provided.innerRef}>
                  <Row xs={1} md={2} className="g-3">
                    <div className="previewSlidesContainer">
                      {" "}
                      <div className="previewReportTitle">
                        {overview != "" && overview != undefined ? (
                          <div>
                            <Form.Control
                              as="textarea"
                              ref={textareaRefTitle}
                              onChange={onReportTitleChange}
                              placeholder="Add your title"
                              value={reportTitle}
                              rows={1}
                              className="previewReportTitle"
                            />
                            <Form.Control
                              as="textarea"
                              ref={textareaRefOverview}
                              onChange={onReportOverviewChange}
                              placeholder=""
                              rows={3}
                              value={overview}
                              className="previewReportOverview"
                            />
                          </div>
                        ) : (
                          <Form.Control
                            as="textarea"
                            ref={textareaRefTitle}
                            onChange={onReportTitleChange}
                            placeholder="Add your title"
                            value={reportTitle}
                            rows={1}
                            className="previewReportTitle"
                          />
                        )}
                      </div>
                      {slides.map((slide, index) => (
                        <Col key={index}>
                          <Draggable
                            key={slide.id}
                            draggableId={slide.id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className="slidePreview"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  background: snapshot.isDragging
                                    ? "#f0f0f0"
                                    : "white",
                                  cursor: "grab",
                                }}
                              >
                                <SlidePreview
                                  key={index}
                                  slide={slide}
                                  index={index}
                                  setSlides={setSlides}
                                  setRadioNumPagesName={setRadioNumPagesName}
                                  setNumPages={setRadioNumPagesName}
                                  slidesLength={slides.length}
                                />
                              </div>
                            )}
                          </Draggable>
                        </Col>
                      ))}
                    </div>
                  </Row>
                </Container>
              )}
            </Droppable>
          </DragDropContext>
          <div className="fixedFooter">
            {" "}
            {isAddingSlide ? (
              <div>
                {" "}
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Button
                variant="outline-primary"
                className="generateJamButton"
                onClick={addCard}
              >
                Add a Slide
              </Button>
            )}
            <br></br>
            <Button className="generateJamButton" onClick={generateReport}>
              Generate Jam
            </Button>
          </div>
        </div>
      ) : (
        <div className="pendingOutlineGeneration">
          {" "}
          Generating Outline
          <p>&nbsp;</p>
          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </div>
  );
};

export default OutlineEditor;
